import { DropdownSelectedItem, dropdownStyle } from '@tableau/data-catalog-shared';
import { DropdownButtonType, List, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import * as React from 'react';
import { defaultMemoize } from 'reselect';

import { Messages } from '../../../gen-src/Localize';
import { WorkbookQuery_workbooks_embeddedDatasources } from '../../../gen-src/queries/WorkbookQuery';

function createListItems(embeddedDatasources: ReadonlyArray<WorkbookQuery_workbooks_embeddedDatasources>): ListItem[] {
  return embeddedDatasources.map(embeddedDatasource => {
    return {
      value: embeddedDatasource.id,
      content: embeddedDatasource.name || Messages.PermissionsRequired(),
      tooltip: embeddedDatasource.name || Messages.PermissionsRequired()
    };
  });
}

export type WorkbookEmbeddedDatasourceSelectorProps = {
  readonly vizportalUrlId: string;
  readonly selectedEmbeddedDatasource: string;
  readonly embeddedDatasources: ReadonlyArray<WorkbookQuery_workbooks_embeddedDatasources>;
  readonly updateEmbeddedDatasourceSelection: (embeddedDatasourceId: string) => void;
};

export class WorkbookEmbeddedDatasourceSelector extends React.PureComponent<WorkbookEmbeddedDatasourceSelectorProps> {

  // tslint:disable-next-line:typedef
  private memoizedListItems = defaultMemoize(createListItems);

  private getSelectedDatasourceName(): string {
    const selectedDatasource = this.props.embeddedDatasources.find(ds => ds.id === this.props.selectedEmbeddedDatasource);
    return selectedDatasource && selectedDatasource.name ? selectedDatasource.name : Messages.PermissionsRequired();
  }

  public render(): JSX.Element {
    const listItems = this.memoizedListItems(this.props.embeddedDatasources);
    const selectedDatasourceName = this.getSelectedDatasourceName();
    return (
      <SingleSelectDropdown
        label={''}
        list={
          <List
            items={listItems}
            selectedValue={this.props.selectedEmbeddedDatasource}
          />
        }
        type={DropdownButtonType.Outline}
        value={this.props.selectedEmbeddedDatasource}
        onChange={this.props.updateEmbeddedDatasourceSelection}
        style={dropdownStyle}
      >
        <DropdownSelectedItem title={selectedDatasourceName}>{selectedDatasourceName}</DropdownSelectedItem>
      </SingleSelectDropdown>
    );
  }
}
